var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1c6.617 0 12 4.244 12 9.461C24 15.721 18.617 20 12 20h-1.436c-1.956 2.845-6.341 2.995-6.538 3H4a1.003 1.003 0 01-.782-1.624c.016-.02 1.437-1.828 1.719-3.72C2.446 16.409 0 13.774 0 10.461 0 5.244 5.383 1 12 1zm0 2C6.486 3 2 6.347 2 10.461c0 2.563 2.191 4.778 4.355 5.642.38.151.629.519.629.928 0 1.327-.472 2.625-.98 3.636 1.156-.317 2.492-.933 3.107-2.126A1 1 0 0110 18h2c5.514 0 10-3.382 10-7.539C22 6.347 17.514 3 12 3z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconChat;